import axiosClient from './axiosClient';

export const redeemReward = async (itemIndex) => {
  try {
    const response = await axiosClient.post('v1/redeem-item', {
      item: itemIndex
    });
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
};

export const completeRedemption = async (data) => {
  try {
    const response = await axiosClient.post('v1/redeem-claim', JSON.stringify(data));
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const callGameNow = async (data) => {
  try {
    const response = await axiosClient.post('v1/gamenow/notify', JSON.stringify(data));
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const getRewardsList = async () => {
  try {
    const response = await axiosClient.post('v1/rewards');
    if (response.data?.success && Array.isArray(response.data?.items)) {
      const normalized = response.data.items
        .map(item => ({ ...item, credits: item.price?.credits }))
        .sort((a, b) => a.position - b.position);
      return { ...response, data: normalized };
    }
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}